import HttpClientToken from '../../services/HttpClientToken';

import { defaultTipoIdentificacion, TipoIdentificacionProps } from '../../interfaces/catalogos/TipoIdentificacionInterface';

export const TipoIdentificaciones = () => {

    return new Promise<TipoIdentificacionProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoIdentificacion/', token)
            .then( ({ data } : { data : TipoIdentificacionProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerTipoIdentificacion = () => {

    return new Promise<TipoIdentificacionProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoIdentificacion/ObtenerTipoIdentificaciones', token)
            .then( ({ data } : { data : TipoIdentificacionProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarTipoIdentificacion = ( params: TipoIdentificacionProps ) => {

    return new Promise<TipoIdentificacionProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoIdentificacion/Actualizar', params, token)
            .then( ({ data } : { data : TipoIdentificacionProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve({ ...defaultTipoIdentificacion });
            });

        }

    });

}

export const AgregarTipoIdentificacion = ( params: TipoIdentificacionProps ) => {

    return new Promise<TipoIdentificacionProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoIdentificacion/Agregar', params, token)
            .then( ({ data } : { data : TipoIdentificacionProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve({ ...defaultTipoIdentificacion });
            });

        }

    });

}
